export const SET_BRANCHES = 'SET_BRANCHES';
export const SET_STORAGES = 'SET_STORAGES';
export const SET_LOCATIONS = 'SET_LOCATIONS';
export const SET_ASSET_CATEGORIES = 'SET_ASSET_CATEGORIES';
export const SET_CONTRACT_DOC_TYPES = 'SET_CONTRACT_DOC_TYPES';
export const SET_CLIENT_DOC_TYPES = 'SET_CLIENT_DOC_TYPES';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_VALIDATORS = 'SET_VALIDATORS';
export const SET_VALUATORS = 'SET_VALUATORS';
export const SET_FUNDS = 'SET_FUNDS';
export const SET_CASH_LOG_CATEGORIES = 'SET_CASH_LOG_CATEGORIES';
export const SET_ASSET_TYPES = 'SET_ASSET_TYPES';
export const SET_PAYMENT_REMINDER_CLIENT_ATTITUDES = 'SET_PAYMENT_REMINDER_CLIENT_ATTITUDES';
export const SET_PAYMENT_REMINDER_STATUSES = 'SET_CLIENT_LAST_CALL_STATUS';
export const SET_PAYMENT_REMINDER_NEXT_ACTIONS = 'SET_PAYMENT_REMINDER_NEXT_ACTIONS';
export const CLEAR = 'CLEAR';
export const SET_SCREEN_SIZE = 'SET_SCREEN_SIZE';
